module.exports = __webpack_public_path__ + "static/media/back-03.3bfc782b.svg";